export const EMOJI_RENDERER_TYPES = {
  emoji: "emoji",
  icon: "icons",
  shape: "shapes",
  custom: "custom",
};

export const RENDER_IMG_TYPES = ["icons", "shapes", "custom"];
